import { defineMessages } from 'react-intl';

export const messages: {
	moreItemTitle: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	moreItemTitle: {
		id: 'company-hub.links-menu-extension.links-menu-content.links-menu-items.more.title',
		defaultMessage: 'More',
		description: 'Title of dropdown section designated for link items overflown beyond max width',
	},
});
